import React from 'react'

import type {
  ProviderProps,
  KanbanContextData,
} from '../helpers/types/context/kanban.types'

import {
  initialData,
  initialDataCourtyard,
} from '../helpers/types/kanban/state'

export const KanbanContext = React.createContext<KanbanContextData>(
  {} as KanbanContextData
)

export function KanbanProvider({ children }: ProviderProps) {
  const [bookings, setBookings] = React.useState(initialData)
  const [courtyards, setCourtyards] = React.useState(initialDataCourtyard)

  return (
    <KanbanContext.Provider
      value={{ bookings, setBookings, courtyards, setCourtyards }}
    >
      {children}
    </KanbanContext.Provider>
  )
}
